import { MapPin, Navigation, Phone, Mail, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurLakhisaraiLocation() {
  return <section data-section-id="124921" id="find-our-clinic" className="relative w-full h-[700px] md:h-[800px] bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-muted">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.8354345093747!2d-122.41941548468254!3d37.77492947975922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085809c6c8f4459%3A0xb10ed6d9b5050fa5!2sSan%20Francisco%2C%20CA!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="NeuroFamily Clinic Location Map" className="w-full h-full grayscale-[80%] contrast-125" />
        {}
        <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none" aria-hidden="true" />
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none flex flex-col justify-end md:justify-center p-4 md:p-8 lg:p-16 xl:p-24 z-10">
        <Card className="pointer-events-auto w-full max-w-md bg-card/60 backdrop-blur-[20px] shadow-xl border-border/50 rounded-xl">
          <CardHeader className="pb-4">
            <CardTitle className="text-3xl font-bold text-primary font-sans tracking-tight">Visit NeuroFamily</CardTitle>
            <CardDescription className="text-base text-muted-foreground font-sans">
              Advanced neurosurgical care delivered with the compassion of family.
            </CardDescription>
          </CardHeader>
          
          <CardContent className="grid gap-6 pb-6">
            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-2 rounded-full shrink-0 mt-0.5">
                <MapPin className="size-5 text-secondary" />
              </div>
              <div>
                <h4 className="font-medium text-primary font-sans mb-1">Our Institute</h4>
                <p className="text-muted-foreground text-sm leading-relaxed font-sans">1135 GLENDALE BLVD UNIT 5, LOS ANGELES, CA, 90026
              </p>
                <p className="text-secondary text-sm font-medium mt-2 font-sans italic">
                  Note: Complimentary valet parking for all patients.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-2 rounded-full shrink-0 mt-0.5">
                <Clock className="size-5 text-secondary" />
              </div>
              <div>
                <h4 className="font-medium text-primary font-sans mb-1">Clinical Hours</h4>
                <p className="text-muted-foreground text-sm font-sans">
                  24/7 Surgical Support<br />
                  Mon–Fri: 8:00 AM – 6:00 PM<br />
                  Sat: By Appointment Only
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 border-t border-border/50">
              <div className="flex items-center gap-3">
                <Phone className="size-4 text-muted-foreground shrink-0" />
                <span className="text-sm text-muted-foreground font-sans">929-357-7590</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 text-muted-foreground shrink-0" />
                <span className="text-sm text-muted-foreground truncate font-sans" title="care@neurofamily.com">info@seanarminoncology.com</span>
              </div>
            </div>
          </CardContent>

          <CardFooter className="pt-0">
            <Button asChild className="w-full group rounded-full bg-primary text-primary-foreground hover:scale-[1.02] transition-transform duration-300" size="lg">
              <Link to="https://www.google.com/maps/dir/?api=1&destination=NeuroFamily+Medical+Center" newTab>
                <Navigation className="mr-2 size-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                Get Directions
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}